import { Link } from 'react-router-dom';

export default function NewsletterCTA() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20pastel%20candy%20colored%20abstract%20background%20with%20scattered%20confetti%20and%20sparkles%2C%20dreamy%20and%20sweet%20atmosphere%2C%20light%20pink%20and%20cream%20tones%2C%20clean%20and%20minimal%20aesthetic%2C%20soft%20gradient&width=1600&height=600&seq=candy-cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-primary-500/80"></div>
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">
          开启甜蜜之旅
        </h2>
        <p className="text-sm md:text-base text-white/90 mb-8 max-w-lg mx-auto">
          无论是儿童零食、节日礼品还是散装糖果批发，愽彩糖果一站满足您的所有甜蜜需求
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/category/fruit-candy"
            className="px-8 py-3 rounded-full text-sm font-semibold bg-white text-primary-600 hover:bg-white/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            浏览全部糖果
          </Link>
          <Link
            to="/category/bulk-candy"
            className="px-8 py-3 rounded-full text-sm font-semibold bg-white/20 text-white border border-white/40 hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            散装批发采购
          </Link>
        </div>
      </div>
    </section>
  );
}